import z from "zod/v4";

export const createHyperLinkToolParamsSchema = z.object({
  hyperLink: z
    .string()
    .describe(
      "The path of the setting to navigate to. This should come from hyperLink in the setting definition.",
    ),
  messageToMerchant: z
    .string()
    .describe(
      "The message to display to the merchant that will be displayed above the link.",
    ),
  regexToMatch: z
    .string()
    .describe(
      "The regex search pattern that will be used to search the DOM after navigating the setting page and will be automatically highlighted and scrolled to.",
    ),
});

export type CreateHyperLinkToolParams = z.infer<
  typeof createHyperLinkToolParamsSchema
>;
